import { jsx } from 'react/jsx-runtime';
import { InputText } from '../InputText/InputText.js';

const emailRegEx = 
// eslint-disable-next-line -- @typescript-eslint/prefer-named-capture-group
/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function InputEmail({ name, label, placeholder, description, rules, value, defaultValue, disabled, autoComplete, onChange, }) {
    const rulesWithValidation = Object.assign(Object.assign({}, rules), { validate: (emailValue) => {
            return (!emailValue || emailRegEx.test(emailValue) || "Invalid email address");
        } });
    return (jsx(InputText, { type: "email", name: name, label: label !== null && label !== void 0 ? label : "Email", placeholder: placeholder, description: description, rules: rulesWithValidation, value: value, defaultValue: defaultValue, disabled: disabled, autoComplete: autoComplete, onChange: onChange }));
}

export { InputEmail };
//# sourceMappingURL=InputEmail.js.map
